import Vue from 'vue'
import Router from 'vue-router'
import Search from '@/components/Search'
import Home from '@/components/Home'
import Loading from '@/components/Loading'
import Site from '@/components/Site'
import Cameras from '@/components/Cameras'
import Camera from '@/components/Camera'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/loading'
    },
    {
      path: '/site/:siteId',
      name: 'site',
      component: Site,
      children: [
        {
          path: 'cameras',
          name: 'cameras',
          component: Cameras
        },
        {
          path: 'camera/:cameraId',
          name: 'camera',
          component: Camera
        },
        {
          path: '*',
          redirect: '/site/:siteId'
        }
      ]
    },
    {
      path: '/loading',
      name: 'loading',
      component: Loading
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '*',
      redirect: '/loading'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js